'use strict';
// no module, since this is designed to work in a script tag in ie9.
+function () { 
  render();
	/**
	 * given that IE is the only mainstream browser that no longer updates using a userAgent string
	 * to detect it is reasonably safe here. This would not be easy with any other browser especially 
	 * given how they constantly update. Thus this is only to detect IE and throw up that message.
	 */
	function detectIE() {
		var userAgent = window.navigator.userAgent;
		// IE10 and under use MSIE
		var isIE10 = userAgent.indexOf('MSIE') !== -1;
		// IE11 uses Trident
    var isIE11 = userAgent.indexOf('Trident') !== -1;
		// we don't really care which version of IE it is. Just if IE, go away.
		return isIE10 || isIE11;
	}

	function createBrowserLink(label, url) {
		var link = document.createElement('a');
		var linkText = document.createTextNode(label);
    link.appendChild(linkText);
    // forcing styles here because design system gets loaded after, except broken css variables happen 
    // and i can't stop angular from adding stuff to index so I'm just going to inject the styles here
		link.href = url;
		return link;
	}

	function createTextElement(text) {
		var textElement = document.createElement('p');
		textElement.innerText = text;
		return textElement;
	}

	function createSupportedBrowserList() {
    var list = document.createElement('ul');

		var chromeLink = createBrowserLink('Chrome', 'https://www.google.com/chrome/');
		var fireFoxLink = createBrowserLink('FireFox', 'https://www.mozilla.org/en-US/firefox/new/');
		var safari = document.createTextNode('Safari');
		var edge = document.createTextNode('Edge');

		[chromeLink, fireFoxLink, safari, edge].forEach(function(item) {
			var listItem = document.createElement('li');
			listItem.appendChild(item);
			list.appendChild(listItem);
		});

		return list;
	}

	function getAlertIcon() {
		var iconSVG = '<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
			'<title>other/alert</title>' +
			'<desc>alert icon</desc>' +
			'<defs>' +
			'<path d="M9.43213258,4.34612892 C9.97884849,3.44479398 10.9513707,2.897256 12,2.897256 C13.0486293,2.897256 14.0211515,3.44479398 14.5678674,4.34612892 L23.0459905,18.4999396 C23.5790281,19.4230391 23.5822106,20.55966 23.0543507,21.4857299 C22.5264909,22.4117999 21.5468725,22.9882243 20.47,23 L3.51900947,22.9999396 C2.4531275,22.9882243 1.47350913,22.4117999 0.94564925,21.4857299 C0.41778937,20.55966 0.420971911,19.4230391 0.962132578,18.4861289 L9.43213258,4.34612892 Z M2.68599053,19.5000604 C2.50831134,19.8077602 2.5072505,20.1866339 2.68320379,20.4953238 C2.85915708,20.8040138 3.18569654,20.9961553 3.53,21 L20.4590095,21.0000604 C20.8143035,20.9961553 21.1408429,20.8040138 21.3167962,20.4953238 C21.4927495,20.1866339 21.4916887,19.8077602 21.3221326,19.5138711 L12.855,5.378628 C12.6737172,5.07976866 12.3495431,4.897256 12,4.897256 C11.6512233,4.897256 11.3277045,5.07896919 11.1461945,5.37666387 L2.68599053,19.5000604 Z M12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 C12.5522847,16 13,16.4477153 13,17 C13,17.5522847 12.5522847,18 12,18 Z M11,10 C11,9.44771525 11.4477153,9 12,9 C12.5522847,9 13,9.44771525 13,10 L13,14 C13,14.5522847 12.5522847,15 12,15 C11.4477153,15 11,14.5522847 11,14 L11,10 Z" id="path-1"></path>' +
			'</defs>' +
			'<g id="other/alert" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
			'<g id="alert-triangle">' +
			'<mask id="mask-2" fill="white">' +
			'<use xlink:href="#path-1"></use>' +
			'</mask>' +
			'<use id="Combined-Shape" fill="#000000" fill-rule="nonzero" xlink:href="#path-1"></use>' +
			'<g id="Color/Grayscale/10" mask="url(#mask-2)" fill="#121A26">' +
			'<rect id="Swatch" x="0" y="0" width="24" height="24"></rect>' +
			'</g>' +
			'</g>' +
			'</g>' +
			'</svg>';
		var iconElement = document.createElement('span');
		iconElement.innerHTML = iconSVG;
		return iconElement;
	}

	function setStyles() {
    var styleSheet = document.createElement('style');
    var styles = 'html { height: 100%; width: 100%; font-family: Arial, Helvetica, sans-serif;}' +
    'body { height: 100%; width: 100%; margin: 0; padding: 0; }' +
    '.browser-support { position: fixed; height: 100%; width: 100%; top: 0; left: 0; background: #fff; padding: 24px; text-align: center; }' +
    '.browser-support p { font-size: 18px; }' +
    '.browser-support__wrapper { display: inline-block; text-align: left; max-width: 600px; min-width: 300px; padding-top: 36px; }' + 
    '.browser-support__icon { width: 36px; height: 36px; display: inline-block; margin-right: 12px;  margin-bottom: -2px} ' +
    '.browser-support__icon svg{ width: 100%; height: 100%; display: block; } ' +
    '.browser-support__title { font-size: 36px; }' +
    '.browser-support__list { list-style-type: none; margin-bottom: 24px;}' +
    // yes, !important is usually bad practice. Don't do this in your regular css. 
    // However, because this is just a one page-blocker that needs to override css variables 
    // that IE can't read and will break how a tags are rendered
    // it's either this or inline css and the concerns surrounding !important doesn't actually apply here anyway.
    '.browser-support__list a { color: #2751bf !important; font-weight: bold; font-decoration: none;}' +
    '.browser-support__list a:hover { color: #6885d3 !important;}' +
    '.browser-support p.browser-support__upgrade { font-size: 14px; }'
    ;
    
    styleSheet.appendChild(document.createTextNode(styles));
    document.head.appendChild(styleSheet);
  }

  // ie9 friendly version
  function addClass(element, className){
    var classList = element.className;
    var newList = classList.concat(' '+className);
    element.className = newList;
  }
  
  function createIEBlocker() {
    var blocker = document.createElement('div');
    var wrapper = document.createElement('div');
    var title = document.createElement('h1');
    var unsupportedBrowserMessage = document.createTextNode('Unsupported Browser');
		var alertIcon = getAlertIcon();
		var sorryMessage = createTextElement('We are sorry, but Internet Explorer is not supported.');
		var workingMessage = createTextElement('We support these following browsers:');
		var safariEdgeMessage = createTextElement('For Safari and Edge, please upgrade to the latest version through your system\'s software updates.');
		var supportedBrowserList = createSupportedBrowserList();

    // set classes
    addClass(blocker,'browser-support');
    addClass(wrapper,'browser-support__wrapper');
    addClass(title,'browser-support__title');
    addClass(alertIcon,'browser-support__icon');
    addClass(supportedBrowserList,'browser-support__list');
    addClass(safariEdgeMessage,'browser-support__upgrade');
    title.appendChild(alertIcon);
    title.appendChild(unsupportedBrowserMessage);

		wrapper.appendChild(title);
		wrapper.appendChild(sorryMessage);
		wrapper.appendChild(workingMessage);
		wrapper.appendChild(supportedBrowserList);
		wrapper.appendChild(safariEdgeMessage);

    blocker.appendChild(wrapper);

		return blocker;
	}

  function render() {
		if (!detectIE()) {
			return;
    }    
    setStyles();
    var ieBlocker = createIEBlocker();
    // clear out body in case of angular actually partially working but still broken, we just
    // don't let it run anyway
    while(document.body.firstChild){
      document.body.removeChild(document.body.firstChild);
    }
    document.body.appendChild(ieBlocker);
	}
}();
